// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1) return "packs/css/application-c6b59dd1.css";
	// return url for filenames based on template
	return "packs/css/" + "date_picker" + "-" + "303449a1" + ".chunk.css";
};